<p style="padding-left: 32px; font-size: 18px;">Stai per chiamare il numero: {{phone}}</p>
